import { render, staticRenderFns } from "./HotSigns.vue?vue&type=template&id=ad142126&scoped=true&lang=pug&"
import script from "./HotSigns.vue?vue&type=script&lang=js&"
export * from "./HotSigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad142126",
  null
  
)

export default component.exports